module.exports = __webpack_public_path__ + "img/1F1F0-1F1EE.c1f64142.svg";